import { useSelector } from 'react-redux';
import { Container } from '../../models';
import { selectContainers } from '../../selectors';

export const useContainers = (): Container[] => {
  const containers = useSelector(selectContainers);

  return containers;
};
